module.exports = __webpack_public_path__ + "static/burger-4e86a5a527da6616e030ab91d45688a3.png";